import React, { memo } from 'react';
import Styles from './auth-header-partner-styles.scss';
import Preview from './preview';
import { useSearchParams } from 'react-router-dom';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import usePartner from '@/presentation/hooks/use-partner';
const AuthHeaderPartner = ({ headerSignUp = false, headerDashboard = false }) => {
    var _a, _b, _c;
    const [searchParams] = useSearchParams();
    const idPartnerPreview = searchParams.get('idPartnerPreview');
    const isPreview = !!idPartnerPreview;
    const { user } = useUserSesssion();
    const { urlLogo, partner } = usePartner({
        userId: user === null || user === void 0 ? void 0 : user.id,
        idPartnerPreview
    });
    if (!urlLogo)
        return null;
    if (headerDashboard) {
        if (!((_a = partner === null || partner === void 0 ? void 0 : partner.logoPlacements) === null || _a === void 0 ? void 0 : _a.userHomePages))
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: Styles.wrapDas },
                React.createElement("div", { className: Styles.title },
                    React.createElement("span", null, "powered by")),
                React.createElement("div", { className: Styles.icon },
                    React.createElement("img", { src: urlLogo, alt: "logo" }))),
            React.createElement(Preview, { isPreview: isPreview })));
    }
    console.log('headerSignUp', headerSignUp);
    console.log('partner?.logoPlacements:', partner === null || partner === void 0 ? void 0 : partner.logoPlacements);
    if (headerSignUp && !((_b = partner === null || partner === void 0 ? void 0 : partner.logoPlacements) === null || _b === void 0 ? void 0 : _b.registrationPages))
        return null;
    if (!headerSignUp && !((_c = partner === null || partner === void 0 ? void 0 : partner.logoPlacements) === null || _c === void 0 ? void 0 : _c.loginPages))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.wrap, style: { flexDirection: headerSignUp ? 'row' : 'column' } },
            React.createElement("div", { className: Styles.title },
                React.createElement("span", null, "powered by")),
            React.createElement("div", { className: Styles.icon },
                React.createElement("img", { src: urlLogo, alt: "logo" }))),
        React.createElement(Preview, { isPreview: isPreview })));
};
export default memo(AuthHeaderPartner);
